var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65768 9.1665L13.666 9.1665L13.666 10.8332L3.65768 10.8332L3.65768 13.3332L0.332684 9.99984L3.65768 6.6665L3.65768 9.1665Z",
    fill: "#15162B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6743 2.5L0.666016 2.5L0.666016 4.16667L10.6743 4.16667L10.6743 6.66667L13.9993 3.33333L10.6743 -8.69779e-07L10.6743 2.5Z",
    fill: "#15162B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionHr);
export default __webpack_public_path__ + "static/media/direction-hr.9e945389cda3a04e89f5887225b5a7fc.svg";
export { ForwardRef as ReactComponent };